const MOMENT_FORMATS = {
  MONTH_DAYS_YEAR: 'MMM DD YYYY',
  HOURS_MINUTES: 'HH:mm',
  DATE_FORMATS: 'DD MMM YYYY, HH:mm'
}

export { MOMENT_FORMATS }
export default MOMENT_FORMATS
